import { render, staticRenderFns } from "./CheckType.vue?vue&type=template&id=3a572b74&"
import script from "./CheckType.vue?vue&type=script&lang=js&"
export * from "./CheckType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports